export default "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7 9.5L12 14.5L17 9.5H7Z\"></path>\n</svg>"